export interface ProductSortListProps {
    selectedValue?: ProductSortType;
    handleSortSelection: (sortType: ProductSortType) => void;
}

export type ProductSortType = 0 | 1 | 2 | 3;
const UNKNOWN_SORT_TYPE: ProductSortType = 0;
const LOWER_PRICE: ProductSortType = 1;
const UPPER_PRICE: ProductSortType = 2;
const NAME: ProductSortType = 3;

export const ProductSortTypeValues = {
    UNKNOWN: UNKNOWN_SORT_TYPE,
    LOWER_PRICE,
    UPPER_PRICE,
    NAME,
};
